var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-checkbox",class:{ 'checkbox-right': _vm.position === 'right' }},[_c('el-checkbox',{attrs:{"value":_vm.selected},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }